import {
  Action as RadixToastAction,
  type ToastActionProps,
} from '@radix-ui/react-toast';
import { Button, ButtonProps } from '../button/button';
import { toastAction } from './toast-action.css';

export const ToastAction = function ToastAction({
  ref,
  children,
  altText,
  ...props
}: ButtonProps & { altText: ToastActionProps['altText'] }) {
  return (
    <RadixToastAction
      className={toastAction}
      ref={ref}
      altText={altText}
      asChild
    >
      <Button size="small" inversed variant="ghost" {...props}>
        {children}
      </Button>
    </RadixToastAction>
  );
};
export type ToastActionElement = React.ReactElement<typeof ToastAction>;
